import { Box, Heading } from 'grommet'
import styled, { css } from 'styled-components'

export const OrangeSpan = styled.span`
  ${({ theme }) => css`
    color: ${theme.newColors.accent};

    ${theme.below.mobileXL`
      color: ${theme.newColors.white};
    `}
  `}
`

export const ListSpan = styled.span`
  ${({ theme }) => css`
    font-weight: ${theme.typography.desktop.title.title5.fontWeight};
  `}
`

export const FormTitle = styled.span`
  display: block;

  ${({ theme }) => theme.below.laptop`
    margin-top: ${theme.newSpaces.md}px;
  `}
`

export const HeaderTitleWrapper = styled(Heading)`
  ${({ theme }) => css`
    ${theme.getTypography('desktop', 'title', 'blog')};

    color: ${theme.newColors.white};
    text-transform: uppercase;

    ${theme.below.tablet`
      ${theme.getTypography('desktop', 'title', 'title1')};

      padding: ${theme.newSpaces.xs2}px;
      max-width: 600px;
    `}

    ${theme.below.mobileXL`
      ${theme.getTypography('mobile', 'title', 'blog')};

      max-width: 100%;
      padding: 0 ${theme.newSpaces.xs}px;
      text-shadow: 4px 4px 4px rgba(0, 0, 0, 0.25);
    `}
  `}
`

export const TitleWrapper = styled(Box)`
  width: 655px;

  ${({ theme }) => css`
    ${theme.getTypography('desktop', 'title', 'title1')};

    color: ${theme.newColors.primary};
    margin-top: ${theme.newSpaces.xl5}px;
    width: 100%;

    ${theme.below.mobileXL`
      ${theme.getTypography('desktop', 'title', 'title2')};

      margin-top: ${theme.newSpaces.xl2}px;
    `}
  `}
`

export const TextTitle = styled(Box)`
  text-align: justify;

  ${({ theme }) => css`
    ${theme.getTypography('desktop', 'title', 'title2')}

    color: ${theme.newColors.darkGray};

    ${theme.below.mobileXL`
      ${theme.getTypography('mobile', 'title', 'title4')};
    `}
  `}
`
